module.exports = __webpack_public_path__ + "img/big-bottle-pink.7c048060.svg";